var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.79375 0.98125C1.01875 0.75625 1.375 0.75625 1.58125 0.98125L7.20625 6.60625C7.43125 6.83125 7.43125 7.1875 7.20625 7.39375L1.58125 13.0187C1.46875 13.1312 1.31875 13.1875 1.1875 13.1875C1.05625 13.1875 0.90625 13.1312 0.79375 13.0187C0.56875 12.7937 0.56875 12.4375 0.79375 12.2313L6.025 7L0.79375 1.76875C0.56875 1.54375 0.56875 1.20625 0.79375 0.98125Z",
    fill: "#444B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIconDark);
export default __webpack_public_path__ + "static/media/arrow-right-icon-dark.e0871b45b48ed50109afcb12f242d663.svg";
export { ForwardRef as ReactComponent };